import React, { useState } from "react";

const Aconv = () => {
  const [status, setStatus] = useState("");

  const handleSendMail = async () => {
    setStatus("Sending...");
    try {
      const response = await fetch("https://cloud.hxabyte.com/send-mail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.success) {
        setStatus("✅ Email sent! Message ID: " + data.messageId);
      } else {
        setStatus("❌ Failed to send: " + data.error);
      }
    } catch (err) {
      setStatus("❌ Network error: " + err.message);
    }
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial", textAlign: "center" }}>
      <button
        onClick={handleSendMail}
        style={{
          padding: "12px 24px",
          fontSize: "16px",
          backgroundColor: "#4CAF50",
          color: "#fff",
          marginTop: "20px",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Send Mail
      </button>
      <p style={{ marginTop: "15px", fontWeight: "bold" }}>{status}</p>
    </div>
  );
};

export default Aconv;
